import cx from 'classnames'
import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {Body1, Body2, Caption} from '@adv-mt/ui/typography'

import {BASE_CLASS} from '../config.js'

const FinancingDetails = ({legalLiteralKey, onLegalConditionsClick, rows, showsTitle}) => {
  const {i18n} = useSuiContext()

  return (
    <div className={`${BASE_CLASS}-details`}>
      {showsTitle && <Body1 highlight>{i18n.t('COMMON.OFFER_DETAILS')}</Body1>}
      <div className={`${BASE_CLASS}-detailsPanel`}>
        {rows.length > 0 && (
          <ul className={`${BASE_CLASS}-table`} role="list">
            {rows.map(({extraLabel, id, isBold, isHighlighted, label, value}) => (
              <li className={cx(`${BASE_CLASS}-tableRow`, isBold && `${BASE_CLASS}-tableRow--highlighted`)} key={id}>
                <span className={`${BASE_CLASS}-tableLabel`}>
                  <Body2 as="span" highlight={isBold}>
                    {label}
                  </Body2>
                  {extraLabel && (
                    <Caption as="span" className={`${BASE_CLASS}-tableExtraLabel`}>
                      {extraLabel}
                    </Caption>
                  )}
                </span>
                <Body2 as="span" highlight>
                  {value}
                  {isHighlighted && <span aria-hidden="true">**</span>}
                </Body2>
              </li>
            ))}
          </ul>
        )}
        <button className={`${BASE_CLASS}-legalLink`} onClick={onLegalConditionsClick} type="button">
          <span aria-hidden="true">*</span>
          <Body2 as="span" highlight>
            {i18n.t(legalLiteralKey)}
          </Body2>
        </button>
      </div>
    </div>
  )
}

FinancingDetails.displayName = 'FinancingDetails'

FinancingDetails.propTypes = {
  legalLiteralKey: PropTypes.string.isRequired,
  onLegalConditionsClick: PropTypes.func.isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      extraLabel: PropTypes.string,
      id: PropTypes.string.isRequired,
      isBold: PropTypes.bool,
      isHighlighted: PropTypes.bool,
      label: PropTypes.string.isRequired,
      value: PropTypes.string
    })
  ).isRequired,
  showsTitle: PropTypes.bool.isRequired
}

export default FinancingDetails
